import { LiveGame } from '@/features/v2/casino/interfaces/game.interface';

// Datos fake para mostrar mientras cargan los datos reales
export const generateFakeLiveGames = (count: number = 8): LiveGame[] => {
  const fakeGames: LiveGame[] = [];
  const providers = ['Pragmatic Play', 'Evolution', 'NetEnt', 'Microgaming', 'Play\'n GO', 'Red Tiger'];
  const gameNames = ['Sweet Bonanza', 'Gates of Olympus', 'Book of Dead', 'Starburst', 'Gonzo\'s Quest', 'Mega Moolah'];

  for (let i = 0; i < count; i++) {
    const provider = providers[Math.floor(Math.random() * providers.length)];
    const gameName = gameNames[Math.floor(Math.random() * gameNames.length)];
    const amount = Math.random() * 5000 + 100; // Entre 100 y 5100
    const nick = `Player${Math.floor(Math.random() * 9999) + 1}`;

    fakeGames.push({
      id: `fake-${i}-${Date.now()}`,
      identifier: `${provider}:${gameName}`,
      i_gamedesc: gameName,
      nick,
      amount: Math.round(amount * 100) / 100,
      provider,
      created_at: new Date(),
      thumb_url: '',
      features: '',
    });
  }

  return fakeGames;
};

// Datos fake específicos para diferentes tipos
export const getFakeDataByType = (type: 'live' | 'highRollers'): LiveGame[] => {
  const baseCount = type === 'highRollers' ? 6 : 8;
  const fakeGames = generateFakeLiveGames(baseCount);

  // Ajustar montos según el tipo
  return fakeGames.map((game) => {
    let adjustedAmount = game.amount;
    if (type === 'highRollers') {
      adjustedAmount = Math.random() * 10000 + 1000; // Entre 1000 y 11000
    }

    return {
      ...game,
      amount: adjustedAmount,
    };
  });
};
